import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "room",
  "use": "room-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"room\">\n<path d=\"M19,22H5c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h14c1.7,0,3,1.3,3,3v2.8c0,0.6-0.4,1-1,1s-1-0.4-1-1V5c0-0.6-0.4-1-1-1H5\n\tC4.4,4,4,4.4,4,5v14c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-2.1l-4.7-5.2c-0.4-0.4-0.3-1,0.1-1.4c0.4-0.4,1-0.3,1.4,0.1l5,5.5\n\tc0.2,0.2,0.3,0.4,0.3,0.7V19C22,20.7,20.7,22,19,22z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol